import { ConfigProvider, StyleProvider, ThemeProvider } from '@carla/flora'
import { config } from './flora'
import { AuthProvider } from './contexts/authContext'

type MainContextProps = {
  children: React.ReactNode
}

export function MainContext({ children }: MainContextProps) {
  return (
    <ConfigProvider config={config}>
      <StyleProvider>
        <ThemeProvider theme="light">
          <AuthProvider>{children}</AuthProvider>
        </ThemeProvider>
      </StyleProvider>
    </ConfigProvider>
  )
}
